module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer-es-68efed15276f4c23089b2df4b0efbda0.svg";